import React from "react";
import { View } from "react-native";
import { styles, invertColors } from "./Message.styles";
import { theme } from "@clearabee/ui-library-base";
import { Icon } from "../Icon/Icon";
import { Text } from "../Text/Text";
const typeMap = {
    info: {
        icon: "attention",
        color: "greyscale",
    },
    warn: {
        icon: "attention",
        color: "warning",
    },
    success: {
        icon: "tick",
        color: "positive",
    },
    error: {
        icon: "attention",
        color: "negative",
    },
};
export const Message = ({ children, styles: userStyles, type, color: userColor, icon: userIcon, small, background, invert, iconContainerStyles, ...rest }) => {
    const colorKey = !userColor && type ? typeMap[type].color : userColor || "greyscale";
    const icon = !userIcon && type ? typeMap[type].icon : userIcon || "attention";
    const size = !small ? "medium" : "small";
    const fontSize = !small ? "base" : "xsmall2";
    const hexColor = invert
        ? invertColors[colorKey] || theme.colors.light.base
        : theme.colors[colorKey].base;
    const IconComponent = Icon[(icon.charAt(0).toUpperCase() + icon.slice(1))];
    return (React.createElement(View, { accessibilityRole: "alert", style: [
            styles.defaults,
            background && styles.background,
            background &&
                invert && {
                backgroundColor: theme.colors[colorKey].base,
            },
            userStyles,
        ], ...rest },
        React.createElement(View, { style: [styles.icon, iconContainerStyles] },
            React.createElement(IconComponent, { size: size, hexColor: hexColor })),
        React.createElement(Text, { fontSize: fontSize, style: {
                color: hexColor,
                flexWrap: "wrap",
            } }, children)));
};
//# sourceMappingURL=Message.js.map